namespace GeniuzPOS.Member {
    export interface PsMemberGenderRow {
        Id?: number;
        MbGender?: string;
        MbGenderName?: string;
    }

    export namespace PsMemberGenderRow {
        export const idProperty = 'MbGender';
        export const nameProperty = 'MbGenderName';
        export const localTextPrefix = 'Member.PsMemberGender';
        export const lookupKey = 'Member.PsMemberGender';

        export function getLookup(): Q.Lookup<PsMemberGenderRow> {
            return Q.getLookup<PsMemberGenderRow>('Member.PsMemberGender');
        }
        export const deletePermission = '3Member:สมาชิก:Delete';
        export const insertPermission = '3Member:สมาชิก:Modify';
        export const readPermission = '3Member:สมาชิก:View';
        export const updatePermission = '3Member:สมาชิก:Modify';

        export declare const enum Fields {
            Id = "Id",
            MbGender = "MbGender",
            MbGenderName = "MbGenderName"
        }
    }
}
